import React from 'react';
import styled, { css } from 'styled-components';

import { ContentContainerSmall } from '@/components/ContentContainer';
import { media } from '@/utils/mixin';

import Header from './components/Header';
import Content from './components/Content';
import Dealerships from './components/Dealerships';
import Promotion from './components/Promotion';

function Main() {
  return (
    <Component>
      <ContentContainerSmall>
        <Wrapper>
          <ContentSide>
            <Header />
            <Content />
            <Dealerships />
          </ContentSide>
          <SideBar>
            <Promotion />
          </SideBar>
        </Wrapper>
      </ContentContainerSmall>
    </Component>
  );
}

export default Main;

const Component = styled.section`
  padding: 60px 0 30px;

  ${media.tablet(css`
    padding: 40px 0 20px;
  `)}

  ${ContentContainerSmall} {
    ${media.tablet(css`
      padding: 0 20px;
      max-width: none;
    `)}
  }
`;

const Wrapper = styled.div`
  position: relative;
  display: flex;
  justify-content: flex-end;
  background: ${(props) => props.theme.white};

  ${media.tablet(css`
    flex-direction: column;
    padding-top: 0;
  `)}
`;

const ContentSide = styled.div`
  flex: 1 1 585px;
  max-width: 585px;

  ${media.tablet(css`
    flex: auto;
    max-width: none;
  `)}
`;

const SideBar = styled.div`
  position: relative;
  flex: 1 1 400px;
  max-width: 400px;
  margin-left: 30px;

  ${media.tablet(css`
    flex: auto;
    max-width: none;
    margin-left: 0;
    margin-top: 30px;
  `)}
`;
